export const places = [
  {
    id: 'playground',
    number: '09',
    name: 'Adventure Playground',
    category: 'gardens',
    kind: 'Family adventure',
    coordinates: [-0.78355 - 170 / 67084, 52.89315 + 99 / 111195],
    lift: 14,
    description: 'Woodland adventure beside the arrival area and Vale View Cafe.',
    detail:
      'Discover the timber castle maze, HMS Resolution, zip wire and little wooden Renault. This model draws on the playground designer’s photographs, with placement corrected from the owner’s reference.',
    source: 'https://wearecapco.com/us/project/adventure-playground-at-belvoir-castle/',
  },
  {
    id: 'cafe',
    number: '10',
    name: 'Vale View Cafe',
    category: 'essentials',
    kind: 'Cafe & picnic stop',
    coordinates: [-0.78355 - 171.4 / 67084, 52.89315 + 153.35 / 111195],
    lift: 10,
    description: 'Vale View Cafe occupies the arrival building beside the ticket office.',
    detail:
      'Look for the cafe sign and picnic benches, with the playground alongside. Building identification follows the owner’s correction; architectural details remain illustrated.',
    source: 'https://www.belvoircastle.com/memberships',
  },
  {
    id: 'castle',
    number: '01',
    name: 'Belvoir Castle',
    category: 'gardens',
    kind: 'Castle & heritage',
    coordinates: [-0.78259865, 52.89473497],
    lift: 40,
    markerOffset: [-24, -18],
    description: 'The castle crowns the hill, overlooking the Vale of Belvoir.',
    detail:
      'The present castle took shape in the early 19th century. Explore its setting and the gardens unfolding below it.',
    source: 'https://historicengland.org.uk/listing/the-list/list-entry/1000957',
    bee: 'Look for the towers. Which one would you choose as your lookout?',
  },
  {
    id: 'rose',
    number: '02',
    name: 'Rose Garden',
    category: 'gardens',
    kind: 'Formal garden',
    coordinates: [-0.78355 - 34.5 / 67084, 52.89315 + 100.8 / 111195],
    lift: 9,
    description: 'A formal garden of roses, paths and historic ornament, below the castle.',
    detail:
      'Harold Peto designed the garden for Violet, the 8th Duchess. Paths were checked against OpenStreetMap on 11 September 2026. Planting and ornaments are illustrated; current access and any unmapped connections need confirmation by the visitor team.',
    source: 'https://www.belvoircastle.com/about/gardens',
    bee: 'This garden was designed like a boat. Can you imagine its bow and stern?',
  },
  {
    id: 'japanese',
    number: '03',
    name: 'Japanese Woodland',
    category: 'gardens',
    kind: 'Woodland garden',
    coordinates: [-0.7832824, 52.8920952],
    lift: 18,
    description: 'A woodland garden known for magnolias, rhododendrons and camellias.',
    detail:
      'Explore layered flowering shrubs, magnolia-like trees, varied woodland canopies and fern undergrowth. Planting draws on RHS and Burncoose descriptions; individual locations and seasonal flowers are illustrated.',
    source: 'https://www.rhs.org.uk/gardens/partner-gardens/articles/japanese-gardens',
    bee: 'Imagine the woodland in spring. What colours would you paint its flowers?',
  },
  {
    id: 'spiral',
    number: '04',
    name: 'Spiral Walk',
    category: 'gardens',
    kind: 'Historic walk',
    coordinates: [-0.78240383, 52.89458874],
    lift: 8,
    description: 'A winding walk around the slopes of Castle Hill.',
    detail: 'Follow its shape on the map to see how the paths wrap around the hillside. Check local signs for current access.',
    source: 'https://historicengland.org.uk/listing/the-list/list-entry/1000957',
    bee: 'Trace the winding path with your eyes. Can you follow it around the hill?',
  },
  {
    id: 'mausoleum',
    number: '05',
    name: 'Mausoleum',
    category: 'gardens',
    kind: 'Heritage landmark',
    coordinates: [-0.78563057, 52.89108956],
    lift: 16,
    description: 'The family mausoleum sits in the landscape south-west of the castle.',
    detail: 'Built in 1826–28, this is a historic landmark rather than a promise of interior access.',
    source: 'https://historicengland.org.uk/listing/the-list/list-entry/1000957',
    bee: 'Find this quieter corner of the landscape. What might you hear in the trees?',
  },
  {
    id: 'tickets',
    number: '06',
    name: 'Ticket office & entrance',
    category: 'essentials',
    kind: 'Arrival',
    coordinates: [-0.78355 - 157.26 / 67084, 52.89315 + 165.38 / 111195],
    lift: 12,
    description: 'Enter beneath the timber arch, with the ticket office on the left and Vale View Cafe on the right.',
    detail:
      'The illustrated gates open at 9:30am and close at 5pm daily, using UK local time. Toilets sit behind the ticket office. Ask the visitor team about any changes to access.',
    source: 'https://www.openstreetmap.org/way/1120715364',
  },
  {
    id: 'toilets',
    number: '07',
    name: 'Toilets',
    category: 'essentials',
    kind: 'Facilities',
    coordinates: [-0.78355 - 149.88 / 67084, 52.89315 + 158.64 / 111195],
    lift: 10,
    description: 'Toilets behind the ticket office, on the left of the entrance arch.',
    detail: 'Ask staff to confirm opening and the location of accessible facilities. This map does not confirm step-free access.',
    source: 'https://www.openstreetmap.org/way/1120715365',
  },
  {
    id: 'parking',
    number: '08',
    name: 'Castle car park',
    category: 'essentials',
    kind: 'Parking',
    coordinates: [-0.78666305, 52.89423865],
    lift: 4,
    description: 'The mapped castle car park, west of the castle.',
    detail:
      'Follow current signs and parking instructions on arrival. For accessible parking arrangements, check the official visitor information.',
    source: 'https://www.belvoircastle.com/your-visit/directions',
  },
];

const retailOutlets = [
  ['animal-park', 'Animal Park', 'Meet the animals', -120, 430, 'Explore the larger Animal Park behind the Retail Village, with rectangular paddocks, shelters and connecting walks.'],
  ['stuart', 'Stuart the Calf', 'Animal Park', -155, 418, 'Look for Stuart’s cream coat and chestnut patches. Watch him amble, graze and swish his tail.'],
  ['dave', 'Dave the Donkey', 'Animal Park', -83, 418, 'Dave is the big grey donkey with long ears and a dark mane. Watch him wander and stop to graze.'],
  ['retail', 'Belvoir Retail Village', 'Shopping & dining', -211, 306, 'Explore the Engine Yard’s shops, places to eat and pink Vale House.'],
  ['farmshop', 'Farmshop', 'Farm shop', -237.54, 313.6, 'Discover the Farmshop in the long building around the courtyard.'],
  ['wellness', 'Wellness Centre', 'Coming soon', -211.67, 331.14, 'Coming soon: the Wellness Centre at the end of the Farmshop building. Look for the scaffolding and worker preparing the frontage.'],
  ['duchess', 'The Duchess Collection', 'Fashion & homeware', -220.57, 296.71, 'The Duchess Collection occupies the left-hand part of this shared building.'],
  ['petshop', 'Pet Shop', 'Pet shop', -213.57, 288.91, 'The Pet Shop occupies the right-hand part of the building shared with the Duchess Collection.'],
  ['bistro', 'Belvoir Bistro', 'Food & drink', -201.45, 292.33, 'Look for the arched windows and outdoor tables at the Bistro.'],
  ['retail-info', 'Gift Shop & Information', 'Gifts & visitor information', -173.5, 295.16, 'Browse gifts and find visitor information in the building beside Vale House.'],
  ['vale-house', 'Vale House', 'Accommodation', -152.12, 284.14, 'The distinctive pink house at the edge of the Retail Village.'],
  ['crafts', 'Crafts', 'Crafts', -244.64, 275.98, 'Discover the Crafts building near the courtyard entrance.'],
];

retailOutlets.forEach(([id, name, kind, x, y, description], i) => {
  places.push({
    id,
    name,
    kind,
    number: String(i < 3 ? 20 + i : 8 + i),
    category: 'retail',
    coordinates: [-0.78355 + x / 67084, 52.89315 + y / 111195],
    lift: id === 'retail' ? 3 : 15,
    description,
    detail:
      i < 3
        ? 'A playful illustrated animal park. Stuart and Dave are enlarged characters; their paddocks are placed approximately from your reference. Use Pause activity to stop their movement.'
        : 'Outlet locations confirmed by the owner. The buildings and outdoor details are illustrated; check with each outlet for current opening and availability.',
    source: 'https://www.belvoircastle.com/retail-village',
  });
});

places.push({
  id: 'dairy',
  number: '23',
  name: 'Belvoir Dairy',
  category: 'gardens',
  kind: 'The pink Dairy',
  coordinates: [-0.78355 + 98 / 67084, 52.89315 - 71 / 111195],
  lift: 13,
  description: 'The distinctive pink Dairy, with its octagonal tower and Gothic windows.',
  detail:
    'Take a closer look at the slate roofs, white window surrounds and planted entrance walk. Architectural details are illustrated from your reference photograph.',
  source:
    'https://commons.wikimedia.org/wiki/File:Belvoir_Castle,_Leics_-_Dairy_House_-_geograph.org.uk_-_6007010.jpg',
});
places.push({
  id: 'dog-park',
  number: '24',
  name: 'Dog Park',
  category: 'gardens',
  kind: 'Dog walking field',
  coordinates: [-0.78355 - 297.3 / 67084, 52.89315 + 103 / 111195],
  lift: 8,
  description: 'A fenced grass field in the triangle opposite the main car park.',
  detail: 'An open field with a perimeter fence and a dog, illustrated in the location you identified.',
  source: 'https://www.belvoircastle.com/dog-park',
});
places.push(
  {
    id: 'pizza-kitchen',
    number: '25',
    name: 'Pizza Kitchen',
    category: 'retail',
    kind: 'Woodfired pizza',
    coordinates: [-0.78355 - 178 / 67084, 52.89315 + 280 / 111195],
    lift: 8,
    description: 'The pizza kitchen faces into the courtyard beside the white dining marquee.',
    detail: 'Look for the serving counter, chef and smoking oven chimney near the Bistro and Gift Shop & Information.',
    source: 'https://www.belvoircastle.com/retail-village/dining/woodfired-pizza',
  },
  {
    id: 'caravan',
    number: '26',
    name: 'Traditional Caravan',
    category: 'retail',
    kind: 'Decorative caravan',
    coordinates: [-0.78355 - 177 / 67084, 52.89315 + 227 / 111195],
    lift: 6,
    description: 'A traditional bow-top caravan beside the smaller path near the lower junction.',
    detail: 'Look for its curved green roof, yellow painted body and spoked wheels.',
    source: '',
  },
  {
    id: 'pixie-circle',
    number: '27',
    name: 'Pixie Circle',
    category: 'retail',
    kind: 'Spiral labyrinth',
    coordinates: [-0.78355 - 172.2 / 67084, 52.89315 + 264.6 / 111195],
    lift: 5,
    description: 'A small spiral labyrinth directly in front of Vale House, with a stone pixie statue at its centre.',
    detail: 'Follow the spiral with your eyes and find the purple-hatted wizard strolling nearby.',
    source: '',
  }
);
places.push({
  id: 'terrace-toilets',
  number: '28',
  name: 'Castle Terrace Toilets',
  category: 'essentials',
  kind: 'Facilities · Toilets',
  coordinates: [-0.78355 + 69 / 67084, 52.89315 + 242 / 111195],
  lift: 14,
  description: 'Toilets set into the castle terrace retaining wall, beside the lower path.',
  detail: 'Look for the green doors and TOILETS sign, reached by the short path from the Spiral Walk.',
  source: '',
});
places.push(
  {
    id: 'thermal-garden',
    number: '29',
    name: 'Thermal Wellness Garden',
    category: 'retail',
    kind: 'Thermal garden · Coming soon',
    coordinates: [-0.78355 - 228 / 67084, 52.89315 + 374 / 111195],
    lift: 7,
    description: 'A secluded thermal garden behind the Wellness Centre, with warm pools, plunge tubs and sauna huts.',
    detail:
      'A direct rear walkway links the Wellness Centre to the raised garden terrace, with warm pools, loungers, a pergola and screening plants.',
    source: '',
  },
  {
    id: 'maize-maze',
    number: '30',
    name: 'Maize Maze',
    category: 'gardens',
    kind: 'Peacock maize maze',
    coordinates: [-0.78355 - 362.5 / 67084, 52.89315 + 525 / 111195],
    lift: 7,
    description: 'A large maize field beside the Animal Park, with paths following the supplied peacock design.',
    detail: 'Explore the broad fan of feathers and winding outer passages. The entrance connects to the path from the Retail Village.',
    source: '',
  }
);

places.sort((a, b) => Number(a.number) - Number(b.number));

export function mapPosition(lon, lat, lift = 0) {
  const x = (lon + 0.78355) * 67084;
  const n = (lat - 52.89315) * 111195;
  const cx = (-0.78259865 + 0.78355) * 67084;
  const cy = (52.89473497 - 52.89315) * 111195;
  const h =
    8 +
    77 * Math.exp(-((x - cx) ** 2 / 42000 + (n - cy) ** 2 / 41000)) +
    24 * Math.exp(-((x + 30) ** 2 / 65000 + (n + 270) ** 2 / 120000));
  return [x, h + lift, -n];
}

export function getPlace(id) {
  return places.find((p) => p.id === id);
}
